export const DefaultFileTypes = ['application/pdf', 'image/png', 'image/jpg', 'image/jpeg'];
